import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product }) {
  const { addItem } = useCart();

  return (
    <div data-testid="product-card" className="group">
      <Link to={`/product/${product.id}`} className="block relative overflow-hidden bg-[#F3F3F3] aspect-[3/4] mb-4">
        <img src={product.image} alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        <span className="absolute top-3 left-3 px-3 py-1 text-[10px] tracking-[0.15em] uppercase bg-[#0A0A0A] text-white"
          style={{ fontStyle: "normal" }}>Coming Soon</span>

        <div className="absolute bottom-0 left-0 right-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
          <button data-testid="preorder-button"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); addItem(product); }}
            className="w-full bg-[#0A0A0A] text-white py-3 text-xs tracking-[0.2em] uppercase hover:bg-[#1a1a1a] transition-colors duration-300 active:scale-[0.98]"
            style={{ fontStyle: "normal" }}>
            Pre-Order Now
          </button>
        </div>
      </Link>

      <Link to={`/product/${product.id}`} className="block space-y-1">
        <h3 data-testid="product-name"
          className="text-sm tracking-wide text-[#0A0A0A] leading-snug group-hover:opacity-70 transition-opacity">
          {product.name}
        </h3>
        <div className="flex items-center gap-2">
          <span data-testid="product-price" className="text-sm text-[#0A0A0A]" style={{ fontStyle: "normal" }}>
            CHF {product.price.toFixed(2)}
          </span>
          {product.original_price && (
            <span className="text-sm text-[#888] line-through" style={{ fontStyle: "normal" }}>
              CHF {product.original_price.toFixed(2)}
            </span>
          )}
        </div>
      </Link>
    </div>
  );
}
